package com.evoapps.evoshift.ui.user

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.gestures.awaitEachGesture
import androidx.compose.foundation.gestures.awaitFirstDown
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.Timeline
import androidx.compose.material.icons.filled.Warning
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableFloatStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.domain.market.payroll.PayrollFact
import com.evoapps.evoshift.domain.model.CheckStatus
import com.evoapps.evoshift.domain.model.CompensationModel
import com.evoapps.evoshift.domain.model.SystemContractType
import com.evoapps.evoshift.domain.timeline.EmployeeTimeline
import com.evoapps.evoshift.domain.timeline.TimelineAuditAction
import com.evoapps.evoshift.domain.timeline.TimelineAuditEntry
import com.evoapps.evoshift.domain.timeline.TimelineEntry
import com.evoapps.evoshift.domain.timeline.TimelineKind
import com.evoapps.evoshift.domain.timeline.TimelineLane
import com.evoapps.evoshift.domain.timeline.RequestLane
import com.evoapps.evoshift.domain.timeline.TimelineRequests
import evoshift.composeapp.generated.resources.timeline_request_reject_text
import evoshift.composeapp.generated.resources.timeline_request_reject_title
import evoshift.composeapp.generated.resources.timeline_request_withdraw
import evoshift.composeapp.generated.resources.timeline_request_withdraw_text
import evoshift.composeapp.generated.resources.timeline_request_withdraw_title
import com.evoapps.evoshift.ui.DarkText
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.adaptive.ContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.finance.formatMoney
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.viewmodels.EmployeeTimelineViewModel
import com.evoapps.evoshift.viewmodels.TimelineDraft
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.widgets.DialogSection
import com.evoapps.evoshift.widgets.DialogWidth
import com.evoapps.evoshift.widgets.EvoConfirmDialog
import com.evoapps.evoshift.widgets.EvoDateField
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.widgets.EvoDropdown
import com.evoapps.evoshift.widgets.EvoSegmented
import com.evoapps.evoshift.widgets.EvoTextField
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.MissingYear
import com.evoapps.evoshift.widgets.TopBarAction
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.employee_contract_type
import evoshift.composeapp.generated.resources.payroll_rate_hourly
import evoshift.composeapp.generated.resources.payroll_rate_monthly
import evoshift.composeapp.generated.resources.timeline_action_added
import evoshift.composeapp.generated.resources.timeline_action_changed
import evoshift.composeapp.generated.resources.timeline_action_moved
import evoshift.composeapp.generated.resources.timeline_action_removed
import evoshift.composeapp.generated.resources.timeline_add
import evoshift.composeapp.generated.resources.timeline_add_to
import evoshift.composeapp.generated.resources.timeline_add_title
import evoshift.composeapp.generated.resources.timeline_audit_by
import evoshift.composeapp.generated.resources.timeline_audit_dates
import evoshift.composeapp.generated.resources.timeline_audit_title
import evoshift.composeapp.generated.resources.timeline_current
import evoshift.composeapp.generated.resources.timeline_drag_hint
import evoshift.composeapp.generated.resources.timeline_edit_title
import evoshift.composeapp.generated.resources.timeline_empty_lane
import evoshift.composeapp.generated.resources.timeline_entry_description
import evoshift.composeapp.generated.resources.timeline_field_day
import evoshift.composeapp.generated.resources.timeline_field_end_day
import evoshift.composeapp.generated.resources.timeline_field_exam_day
import evoshift.composeapp.generated.resources.timeline_field_fte
import evoshift.composeapp.generated.resources.timeline_field_from
import evoshift.composeapp.generated.resources.timeline_field_hire_day
import evoshift.composeapp.generated.resources.timeline_field_hours
import evoshift.composeapp.generated.resources.timeline_field_kind
import evoshift.composeapp.generated.resources.timeline_field_note
import evoshift.composeapp.generated.resources.timeline_field_rate
import evoshift.composeapp.generated.resources.timeline_field_relief
import evoshift.composeapp.generated.resources.timeline_field_salary
import evoshift.composeapp.generated.resources.timeline_field_training_day
import evoshift.composeapp.generated.resources.timeline_field_until
import evoshift.composeapp.generated.resources.timeline_field_valid_until
import evoshift.composeapp.generated.resources.timeline_from
import evoshift.composeapp.generated.resources.timeline_from_start
import evoshift.composeapp.generated.resources.timeline_from_until
import evoshift.composeapp.generated.resources.timeline_fte_hint
import evoshift.composeapp.generated.resources.timeline_hours_value
import evoshift.composeapp.generated.resources.timeline_intro_mine
import evoshift.composeapp.generated.resources.timeline_intro_team
import evoshift.composeapp.generated.resources.timeline_kind_contract
import evoshift.composeapp.generated.resources.timeline_kind_employment
import evoshift.composeapp.generated.resources.timeline_kind_end
import evoshift.composeapp.generated.resources.timeline_kind_hire
import evoshift.composeapp.generated.resources.timeline_kind_medical
import evoshift.composeapp.generated.resources.timeline_kind_note
import evoshift.composeapp.generated.resources.timeline_kind_not_counted
import evoshift.composeapp.generated.resources.timeline_kind_unpaid
import evoshift.composeapp.generated.resources.timeline_lane_labour
import evoshift.composeapp.generated.resources.timeline_not_counted_hint
import evoshift.composeapp.generated.resources.timeline_unpaid_hint
import evoshift.composeapp.generated.resources.employee_works_unpaid
import evoshift.composeapp.generated.resources.timeline_kind_ohs
import evoshift.composeapp.generated.resources.timeline_kind_pay
import evoshift.composeapp.generated.resources.timeline_kind_student
import evoshift.composeapp.generated.resources.timeline_kind_tax_relief
import evoshift.composeapp.generated.resources.timeline_moving_to
import evoshift.composeapp.generated.resources.timeline_no_pay_terms
import evoshift.composeapp.generated.resources.timeline_not_available
import evoshift.composeapp.generated.resources.timeline_pay_hourly
import evoshift.composeapp.generated.resources.timeline_pay_monthly
import evoshift.composeapp.generated.resources.timeline_pay_salary_fte
import evoshift.composeapp.generated.resources.timeline_read_only
import evoshift.composeapp.generated.resources.timeline_relief_commuting
import evoshift.composeapp.generated.resources.timeline_relief_pit2
import evoshift.composeapp.generated.resources.timeline_relief_youth
import evoshift.composeapp.generated.resources.timeline_remove
import evoshift.composeapp.generated.resources.timeline_remove_hire_text
import evoshift.composeapp.generated.resources.timeline_remove_text
import evoshift.composeapp.generated.resources.timeline_remove_title
import evoshift.composeapp.generated.resources.timeline_save
import evoshift.composeapp.generated.resources.timeline_title_mine
import evoshift.composeapp.generated.resources.timeline_title_of
import evoshift.composeapp.generated.resources.timeline_today
import evoshift.composeapp.generated.resources.timeline_until
import evoshift.composeapp.generated.resources.timeline_valid_until
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.daysUntil
import kotlinx.datetime.minus
import kotlinx.datetime.number
import kotlinx.datetime.plus
import kotlinx.datetime.toLocalDateTime
import org.jetbrains.compose.resources.stringResource
import kotlin.math.roundToInt
import kotlin.time.Instant

/** SH-212: test tags of the wide timeline (lanes, entries, the today line). */
object TimelineTags {
    const val LANES = "timeline-lanes"
    const val TODAY = "timeline-today"
    fun lane(lane: TimelineLane) = "timeline-lane-${lane.kind.name}${lane.fact?.let { "-${it.name}" }.orEmpty()}"
    fun entry(id: String) = "timeline-entry-$id"
}

/** The lanes' colours: light chips with dark text (readable on the cream page). */
private fun TimelineKind.chipColor(): Color = when (this) {
    TimelineKind.HIRE, TimelineKind.END -> Color(0xFFDDE3EC)
    TimelineKind.CONTRACT -> Color(0xFFDCE6F2)
    TimelineKind.PAY -> Color(0xFFF3E7C6)
    TimelineKind.STUDENT -> Color(0xFFDDEFDD)
    TimelineKind.TAX_RELIEF -> Color(0xFFEAE1F3)
    TimelineKind.UNPAID -> Color(0xFFF1E4DC)
    TimelineKind.NOT_COUNTED -> Color(0xFFE2E6EA)
    TimelineKind.OHS_TRAINING -> Color(0xFFFCE8CF)
    TimelineKind.MEDICAL_EXAM -> Color(0xFFD9EFEC)
    TimelineKind.NOTE -> Color(0xFFE9E6DF)
}

private val ExpiringChip = Color(0xFFFFDDB0)
private val ExpiringText = Color(0xFF6B3A00)
private val ExpiredChip = Color(0xFFFFCDD2)
private val ExpiredText = Color(0xFF8A0F14)
private val TodayLine = Color(0xFFC62828)
private val GridLine = Color(0x1F0B1A33)

/** The title of a lane (and of an entry's kind). */
@Composable
fun TimelineLane.label(): String = when (kind) {
    TimelineKind.HIRE, TimelineKind.END -> stringResource(Res.string.timeline_kind_employment)
    TimelineKind.TAX_RELIEF -> fact?.let { reliefLabel(it) } ?: stringResource(Res.string.timeline_kind_tax_relief)
    TimelineKind.NOT_COUNTED -> stringResource(Res.string.timeline_lane_labour)
    else -> kind.label()
}

@Composable
fun TimelineKind.label(): String = stringResource(
    when (this) {
        TimelineKind.HIRE -> Res.string.timeline_kind_hire
        TimelineKind.END -> Res.string.timeline_kind_end
        TimelineKind.CONTRACT -> Res.string.timeline_kind_contract
        TimelineKind.PAY -> Res.string.timeline_kind_pay
        TimelineKind.STUDENT -> Res.string.timeline_kind_student
        TimelineKind.TAX_RELIEF -> Res.string.timeline_kind_tax_relief
        TimelineKind.UNPAID -> Res.string.timeline_kind_unpaid
        TimelineKind.NOT_COUNTED -> Res.string.timeline_kind_not_counted
        TimelineKind.OHS_TRAINING -> Res.string.timeline_kind_ohs
        TimelineKind.MEDICAL_EXAM -> Res.string.timeline_kind_medical
        TimelineKind.NOTE -> Res.string.timeline_kind_note
    }
)

/** A tax relief's name (PIT-0 for young people, PIT-2, commuting costs). */
@Composable
fun reliefLabel(fact: PayrollFact): String = when (fact) {
    PayrollFact.UNDER_26 -> stringResource(Res.string.timeline_relief_youth)
    PayrollFact.TAX_RELIEF -> stringResource(Res.string.timeline_relief_pit2)
    PayrollFact.COMMUTES -> stringResource(Res.string.timeline_relief_commuting)
    else -> payrollFactLabel(fact)
}

/** What an entry says, without its dates: "35,00 zł an hour", "Contract of mandate · 120 h a month". */
@Composable
fun TimelineEntry.valueText(currency: String): String = when (kind) {
    TimelineKind.HIRE, TimelineKind.END, TimelineKind.OHS_TRAINING, TimelineKind.MEDICAL_EXAM -> kind.label()
    TimelineKind.CONTRACT -> {
        val type = contractLabel(SystemContractType.fromId(contractTypeId))
        declaredHours?.let { "$type · ${stringResource(Res.string.timeline_hours_value, it)}" } ?: type
    }
    TimelineKind.PAY -> when (val p = pay) {
        is CompensationModel.Hourly -> stringResource(Res.string.payroll_rate_hourly, formatMoney(p.rate, currency))
        is CompensationModel.MonthlyFixed -> stringResource(Res.string.timeline_pay_salary_fte, stringResource(Res.string.payroll_rate_monthly, formatMoney(p.baseSalary, currency)), p.fte.toString())
        null -> kind.label()
    }
    TimelineKind.STUDENT -> kind.label()
    TimelineKind.TAX_RELIEF -> fact?.let { reliefLabel(it) } ?: kind.label()
    // SH-232: "Works without pay (0,00 zł)", as the employee form's switch says it.
    TimelineKind.UNPAID -> stringResource(Res.string.employee_works_unpaid, formatMoney(0.0, currency))
    TimelineKind.NOT_COUNTED -> kind.label()
    TimelineKind.NOTE -> text.orEmpty()
}

/** When it applies: "from 10.03.2026", "10.03.2026 – 30.06.2026", "valid until 01.04.2026", "from the start". */
@Composable
fun EmployeeTimeline.datesText(entry: TimelineEntry): String {
    val start = entry.from
    val end = endOf(entry)
    return when {
        entry.kind.isMarker -> start?.let(::formatDay).orEmpty()
        entry.kind.staffCheck != null && start == null -> end?.let { stringResource(Res.string.timeline_valid_until, formatDay(it)) }.orEmpty()
        entry.kind.staffCheck != null -> stringResource(Res.string.timeline_from_until, formatDay(start!!), end?.let(::formatDay) ?: "…")
        start == null && end == null -> stringResource(Res.string.timeline_from_start)
        start == null -> stringResource(Res.string.timeline_until, formatDay(end!!))
        end == null -> stringResource(Res.string.timeline_from, formatDay(start))
        else -> stringResource(Res.string.timeline_from_until, formatDay(start), formatDay(end))
    }
}

/**
 * SH-212: one person's timeline at a workplace: from which day each piece of information applies
 * and until when. Wide screens: lanes per kind on one time axis with spans, "from" markers, the
 * today line and expiry warnings; entries are dragged to move them (snapping to days) and tapped
 * to change or remove them. Phones: a list per kind, each entry with its dates to edit.
 * The owner and financial managers edit; the person reads their own.
 */
@Composable
fun EmployeeTimelineScreen(
    viewModel: EmployeeTimelineViewModel,
    onNavigateBack: () -> Unit
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    val snackbarHostState = remember { SnackbarHostState() }
    val shown = (state.error ?: state.message)?.asString()
    LaunchedEffect(shown) {
        shown?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.messageShown()
        }
    }
    val view = state.view
    val wide = LocalWindowWidthClass.current.isExpanded
    val addLabel = stringResource(Res.string.timeline_add)

    Scaffold(
        snackbarHost = { SnackbarHost(snackbarHostState) },
        topBar = {
            EvoTopBar(
                title = if (view == null || view.isMine) stringResource(Res.string.timeline_title_mine)
                else stringResource(Res.string.timeline_title_of, view.personName),
                onBack = onNavigateBack,
                actions = if (state.canEdit) listOf(
                    TopBarAction(addLabel, Icons.Default.Add, { view?.let { viewModel.startAdd(TimelineLane(TimelineKind.NOTE)) } }, prominent = true, iconOnCompact = true)
                ) else emptyList()
            )
        }
    ) { padding ->
        Box(Modifier.padding(padding).fillMaxSize().let { if (wide) it else it.contentWidth(ContentMaxWidth) }) {
            if (state.isLoading) {
                CircularProgressIndicator(Modifier.align(Alignment.Center))
                return@Box
            }
            if (view == null) {
                Text(stringResource(Res.string.timeline_not_available), Modifier.padding(16.dp), style = MaterialTheme.typography.bodyMedium)
                return@Box
            }
            val timeline = view.timeline
            Column(
                modifier = Modifier.fillMaxWidth().verticalScroll(rememberScrollState()).padding(16.dp),
                verticalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                Text(
                    stringResource(if (view.isMine) Res.string.timeline_intro_mine else Res.string.timeline_intro_team),
                    style = MaterialTheme.typography.bodyMedium,
                    color = DarkText.copy(alpha = 0.8f)
                )
                when {
                    !view.canEdit -> Hint(stringResource(Res.string.timeline_read_only))
                    wide -> Hint(stringResource(Res.string.timeline_drag_hint))
                }
                if (!timeline.hasPayTerms && !view.isMine) Hint(stringResource(Res.string.timeline_no_pay_terms))
                if (wide) {
                    TimelineLanes(
                        timeline = timeline,
                        currency = view.currency,
                        canEdit = view.canEdit,
                        onEntry = viewModel::startEdit,
                        onAdd = viewModel::startAdd,
                        onMove = viewModel::move,
                        requests = state.requests,
                        canAddRequests = state.canAddRequests,
                        onAddRequest = viewModel::startNewRequest,
                        onOpenRequest = viewModel::openRequest,
                        onToggleDeclined = viewModel::toggleDeclined
                    )
                } else {
                    TimelineList(
                        timeline = timeline,
                        currency = view.currency,
                        canEdit = view.canEdit,
                        onEntry = viewModel::startEdit,
                        onAdd = viewModel::startAdd
                    )
                    // SH-224: the person's requests, a list per lane.
                    state.requests?.let { requests ->
                        RequestLaneLists(
                            requests = requests,
                            canAdd = state.canAddRequests,
                            onAdd = viewModel::startNewRequest,
                            onOpen = viewModel::openRequest,
                            onToggleDeclined = viewModel::toggleDeclined
                        )
                    }
                }
                if (view.audit.isNotEmpty()) AuditSection(view.audit)
            }
        }
    }

    state.draft?.let { draft ->
        val timeline = view?.timeline ?: return@let
        TimelineEntryDialog(
            draft = draft,
            timeline = timeline,
            problem = state.draftProblem?.asString(),
            saving = state.isSaving,
            onChange = viewModel::updateDraft,
            onSave = viewModel::saveDraft,
            onRemove = draft.editingId?.let { id -> timeline.entry(id)?.let { entry -> { viewModel.askRemove(entry) } } },
            onDismiss = viewModel::dismissDraft
        )
    }
    // SH-224: SH-223's new-request form, for the person, from a request lane's "+".
    state.newRequest?.let { open ->
        NewRequestDialog(
            state = open.form,
            onAddPlace = viewModel::addPlace,
            onAddedPlaceConsumed = viewModel::addedPlaceConsumed,
            initialType = open.initialType,
            onDismiss = viewModel::dismissNewRequest,
            onConfirm = viewModel::submitNewRequest,
            forName = open.forName,
            canApproveNow = open.canApproveNow
        )
    }
    // SH-224: a request opened from the timeline, and what its decision asks.
    val detail = state.detail
    val openRequest = state.openRequest
    if (detail != null && openRequest != null) {
        when {
            detail.overLimit != null -> openRequest.absence?.let { absence ->
                OverLimitDialog(
                    over = com.evoapps.evoshift.viewmodels.OverLimitApproval(absence, detail.overLimit!!),
                    onApprove = viewModel::approveOverLimit,
                    onDismiss = viewModel::dismissOverLimit
                )
            }
            detail.rejecting -> RejectReasonDialog(
                data = RejectDialogData(Res.string.timeline_request_reject_title, Res.string.timeline_request_reject_text) {},
                onConfirm = viewModel::confirmRejectRequest,
                onDismiss = viewModel::cancelRejectRequest
            )
            detail.withdrawing -> EvoConfirmDialog(
                title = stringResource(Res.string.timeline_request_withdraw_title),
                text = stringResource(Res.string.timeline_request_withdraw_text, openRequest.type.label()),
                confirmLabel = stringResource(Res.string.timeline_request_withdraw),
                onConfirm = viewModel::confirmWithdrawRequest,
                onDismiss = viewModel::cancelWithdrawRequest,
                destructive = true
            )
            else -> TimelineRequestDialog(
                request = openRequest,
                canDecide = state.canDecideRequests,
                canEdit = state.canEdit,
                saving = state.requestSaving,
                onApprove = viewModel::approveRequest,
                onReject = viewModel::askRejectRequest,
                onWithdraw = viewModel::askWithdrawRequest,
                onDismiss = viewModel::closeRequest
            )
        }
    }
    state.removing?.let { entry ->
        val name = view?.personName.orEmpty()
        EvoConfirmDialog(
            title = stringResource(Res.string.timeline_remove_title),
            text = if (entry.kind == TimelineKind.HIRE) stringResource(Res.string.timeline_remove_hire_text, name)
            else stringResource(Res.string.timeline_remove_text, entry.lane.label()),
            confirmLabel = stringResource(Res.string.timeline_remove),
            onConfirm = viewModel::confirmRemove,
            onDismiss = viewModel::cancelRemove,
            destructive = true
        )
    }
}

@Composable
private fun Hint(text: String) {
    Text(text, style = MaterialTheme.typography.bodySmall, color = DarkText.copy(alpha = 0.72f))
}

/** How an entry is described to screen readers (and found by the robots): "Pay: 35,00 zł an hour, from 10.03.2026". */
@Composable
private fun EmployeeTimeline.describe(entry: TimelineEntry, currency: String): String =
    stringResource(Res.string.timeline_entry_description, entry.kind.label(), entry.valueText(currency), datesText(entry))

// --- Wide: lanes on one time axis ---------------------------------------------------------------

private val LaneLabelWidth = 176.dp
private val LaneHeight = 44.dp

@Composable
private fun TimelineLanes(
    timeline: EmployeeTimeline,
    currency: String,
    canEdit: Boolean,
    onEntry: (TimelineEntry) -> Unit,
    onAdd: (TimelineLane) -> Unit,
    onMove: (String, Int) -> Unit,
    requests: TimelineRequests? = null,
    canAddRequests: Boolean = false,
    onAddRequest: (RequestLane) -> Unit = {},
    onOpenRequest: (String) -> Unit = {},
    onToggleDeclined: () -> Unit = {}
) {
    // The axis: from a fortnight before the earliest date to six months after today (or the latest date).
    val first = timeline.axis.start
    val last = timeline.axis.endInclusive
    val days = first.daysUntil(last).coerceAtLeast(1)
    Card(
        colors = CardDefaults.cardColors(containerColor = Color.White),
        modifier = Modifier.fillMaxWidth().testTag(TimelineTags.LANES)
    ) {
        BoxWithConstraints(Modifier.fillMaxWidth().padding(vertical = 8.dp)) {
            val density = LocalDensity.current
            val trackWidth = maxWidth - LaneLabelWidth - 48.dp
            val pxPerDay = with(density) { trackWidth.toPx() } / days
            fun xOf(day: LocalDate): Float = first.daysUntil(day) * pxPerDay
            val todayX = xOf(timeline.today)
            val months = generateSequence(LocalDate(first.year, first.month, 1).plus(DatePeriod(months = 1))) { it.plus(DatePeriod(months = 1)) }
                .takeWhile { it <= last }.toList()
            Column {
                // The month axis with the today marker.
                Row(Modifier.fillMaxWidth().height(24.dp)) {
                    Spacer(Modifier.width(LaneLabelWidth))
                    Box(Modifier.width(trackWidth).fillMaxHeight()) {
                        // Full month names (never shortened): every month when there is room, else every few.
                        val step = kotlin.math.ceil(with(density) { 96.dp.toPx() } / (30.4f * pxPerDay)).toInt().coerceAtLeast(1)
                        months.forEachIndexed { index, month ->
                            if (index % step != 0) return@forEachIndexed
                            Text(
                                monthLabel(month, withYear = index < step || month.month.number <= step),
                                style = MaterialTheme.typography.labelSmall,
                                color = DarkText.copy(alpha = 0.75f),
                                maxLines = 1,
                                modifier = Modifier.offset { IntOffset(xOf(month).roundToInt() + 4, 0) }
                            )
                        }
                        Text(
                            stringResource(Res.string.timeline_today),
                            style = MaterialTheme.typography.labelSmall,
                            fontWeight = FontWeight.Bold,
                            color = TodayLine,
                            modifier = Modifier.testTag(TimelineTags.TODAY).offset { IntOffset(todayX.roundToInt() + 4, 12) }
                        )
                    }
                }
                timeline.lanes.forEach { lane ->
                    HorizontalDivider(color = GridLine)
                    Row(Modifier.fillMaxWidth().height(LaneHeight).testTag(TimelineTags.lane(lane)), verticalAlignment = Alignment.CenterVertically) {
                        Text(
                            lane.label(),
                            style = MaterialTheme.typography.labelLarge,
                            color = DeepNavy,
                            maxLines = 2,
                            overflow = TextOverflow.Ellipsis,
                            modifier = Modifier.width(LaneLabelWidth - 8.dp).padding(start = 12.dp)
                        )
                        Spacer(Modifier.width(8.dp))
                        Box(
                            Modifier.width(trackWidth).fillMaxHeight().drawBehind {
                                months.forEach { m -> drawLine(GridLine, Offset(xOf(m), 0f), Offset(xOf(m), size.height), 1f) }
                                drawLine(TodayLine, Offset(todayX, 0f), Offset(todayX, size.height), 2.dp.toPx())
                            }
                        ) {
                            timeline.entriesOf(lane).forEach { entry ->
                                LaneEntry(timeline, entry, currency, first, last, pxPerDay, canEdit, onEntry, onMove)
                            }
                        }
                        if (canEdit && lane.addable(timeline)) {
                            IconButtonWithTooltip(onClick = { onAdd(lane.forAdding(timeline)) }, modifier = Modifier.size(40.dp), tooltip = stringResource(Res.string.timeline_add_to, lane.label())) {
                                Icon(Icons.Default.Add, contentDescription = stringResource(Res.string.timeline_add_to, lane.label()), tint = DeepNavy)
                            }
                        }
                    }
                }
                // SH-224: the person's requests on the same axis.
                requests?.let {
                    RequestLaneRows(
                        requests = it, first = first, last = last, pxPerDay = pxPerDay, trackWidth = trackWidth,
                        labelWidth = LaneLabelWidth, months = months, todayX = todayX, canAdd = canAddRequests, canEdit = canEdit,
                        gridLine = GridLine, todayLine = TodayLine, onAdd = onAddRequest, onOpen = onOpenRequest, onToggleDeclined = onToggleDeclined
                    )
                }
            }
        }
    }
}

/** Whether something can be added in [this] lane: the employment lane only while there is no end yet. */
private fun TimelineLane.addable(timeline: EmployeeTimeline): Boolean =
    kind != TimelineKind.HIRE || timeline.hire == null || timeline.end == null

/** What "+" adds in [this] lane: the employment lane adds the hire, then the end. */
private fun TimelineLane.forAdding(timeline: EmployeeTimeline): TimelineLane =
    if (kind == TimelineKind.HIRE && timeline.hire != null) TimelineLane(TimelineKind.END) else this

@Composable
private fun monthLabel(month: LocalDate, withYear: Boolean): String {
    val name = com.evoapps.evoshift.ui.util.monthName(month.month.number)
    return if (withYear) "$name ${month.year}" else name
}

@Composable
private fun LaneEntry(
    timeline: EmployeeTimeline,
    entry: TimelineEntry,
    currency: String,
    first: LocalDate,
    last: LocalDate,
    pxPerDay: Float,
    canEdit: Boolean,
    onEntry: (TimelineEntry) -> Unit,
    onMove: (String, Int) -> Unit
) {
    val density = LocalDensity.current
    val start = timeline.startOf(entry) ?: first
    val end = timeline.endOf(entry) ?: last
    val startX = first.daysUntil(start) * pxPerDay
    val widthPx = if (entry.kind.isMarker) with(density) { 14.dp.toPx() } else ((start.daysUntil(end) + 1) * pxPerDay).coerceAtLeast(with(density) { 14.dp.toPx() })
    var drag by remember(entry.id) { mutableFloatStateOf(0f) }
    val snappedDays = (drag / pxPerDay).roundToInt()
    val shiftPx = snappedDays * pxPerDay
    val warning = timeline.warningOf(entry)
    val (background, textColor) = when (warning) {
        CheckStatus.EXPIRED -> ExpiredChip to ExpiredText
        CheckStatus.EXPIRING -> ExpiringChip to ExpiringText
        else -> entry.kind.chipColor() to DarkText
    }
    val description = timeline.describe(entry, currency)
    val movingTo = entry.from?.plus(DatePeriod(days = snappedDays))
    // Where the entry is placed now (it follows the finger while dragged): the drag is measured
    // in the track's coordinates, not the moving entry's own.
    val placed = remember(entry.id) { FloatArray(1) }
    Box(
        Modifier
            .offset { IntOffset((startX + shiftPx).roundToInt(), 0).also { placed[0] = it.x.toFloat() } }
            .fillMaxHeight()
            .width(with(density) { widthPx.toDp() } + if (entry.kind.isMarker) 260.dp else 0.dp)
            .testTag(TimelineTags.entry(entry.id))
            .semantics { contentDescription = description }
            .let { m -> if (canEdit) m.clickable { onEntry(entry) } else m }
            .let { m ->
                if (!canEdit) m else m.pointerInputDrag(entry.id, pxPerDay, placement = { placed[0] }, onDrag = { drag = it }, onEnd = {
                    val daysMoved = (drag / pxPerDay).roundToInt()
                    drag = 0f
                    onMove(entry.id, daysMoved)
                }, onCancel = { drag = 0f })
            },
        contentAlignment = Alignment.CenterStart
    ) {
        if (entry.kind.isMarker) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Box(Modifier.size(14.dp).clip(CircleShape).background(if (entry.kind == TimelineKind.END) TodayLine else DeepNavy))
                Spacer(Modifier.width(6.dp))
                Text(
                    "${entry.valueText(currency)} · ${timeline.datesText(entry)}",
                    style = MaterialTheme.typography.labelMedium,
                    color = DarkText,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
        } else {
            Row(
                Modifier.fillMaxWidth().height(30.dp).clip(RoundedCornerShape(8.dp)).background(background)
                    .border(1.dp, DeepNavy.copy(alpha = 0.18f), RoundedCornerShape(8.dp)),
                verticalAlignment = Alignment.CenterVertically
            ) {
                // The "from" marker: where it starts to apply.
                Box(Modifier.width(4.dp).fillMaxHeight().background(DeepNavy))
                Spacer(Modifier.width(6.dp))
                if (warning != null) {
                    Icon(Icons.Default.Warning, contentDescription = null, tint = textColor, modifier = Modifier.size(16.dp))
                    Spacer(Modifier.width(4.dp))
                }
                Text(
                    if (drag != 0f && movingTo != null) stringResource(Res.string.timeline_moving_to, formatDay(movingTo))
                    else "${entry.valueText(currency)} · ${timeline.datesText(entry)}",
                    style = MaterialTheme.typography.labelMedium,
                    color = textColor,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
        }
    }
}

/**
 * Horizontal dragging: [onDrag] with the distance from where the pointer went down (so the entry
 * stays under the pointer, the touch slop included), [onEnd] when let go after moving past the
 * slop. A press without moving stays a tap (the entry's dialog).
 */
private fun Modifier.pointerInputDrag(
    key: Any,
    pxPerDay: Float,
    placement: () -> Float,
    onDrag: (Float) -> Unit,
    onEnd: () -> Unit,
    onCancel: () -> Unit
): Modifier =
    this.then(
        Modifier.pointerInput(key, pxPerDay) {
            awaitEachGesture {
                val down = awaitFirstDown(requireUnconsumed = false)
                val downX = down.position.x + placement()
                var dragging = false
                var released = false
                while (true) {
                    val event = awaitPointerEvent()
                    val change = event.changes.firstOrNull { it.id == down.id } ?: break
                    val dx = change.position.x + placement() - downX
                    if (!dragging && kotlin.math.abs(dx) > viewConfiguration.touchSlop) dragging = true
                    if (dragging) {
                        change.consume()
                        onDrag(dx)
                    }
                    if (!change.pressed) {
                        released = true
                        break
                    }
                }
                if (dragging && released) onEnd() else if (dragging) onCancel()
            }
        }
    )

// --- Phones: a list per kind -------------------------------------------------------------------

@Composable
private fun TimelineList(
    timeline: EmployeeTimeline,
    currency: String,
    canEdit: Boolean,
    onEntry: (TimelineEntry) -> Unit,
    onAdd: (TimelineLane) -> Unit
) {
    timeline.lanes.forEach { lane ->
        Card(
            colors = CardDefaults.cardColors(containerColor = Color.White),
            modifier = Modifier.fillMaxWidth().testTag(TimelineTags.lane(lane))
        ) {
            Column(Modifier.padding(horizontal = 16.dp, vertical = 8.dp)) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Text(lane.label(), style = MaterialTheme.typography.titleSmall, color = DeepNavy, fontWeight = FontWeight.Bold, modifier = Modifier.weight(1f))
                    if (canEdit && lane.addable(timeline)) {
                        IconButtonWithTooltip(onClick = { onAdd(lane.forAdding(timeline)) }, tooltip = stringResource(Res.string.timeline_add_to, lane.label())) {
                            Icon(Icons.Default.Add, contentDescription = stringResource(Res.string.timeline_add_to, lane.label()), tint = DeepNavy)
                        }
                    }
                }
                val entries = timeline.entriesOf(lane)
                if (entries.isEmpty()) {
                    Text(stringResource(Res.string.timeline_empty_lane), style = MaterialTheme.typography.bodySmall, color = DarkText.copy(alpha = 0.7f))
                }
                entries.reversed().forEach { entry ->
                    val warning = timeline.warningOf(entry)
                    val current = entry.kind.isSequential && timeline.currentOf(lane) == entry
                    val description = timeline.describe(entry, currency)
                    Row(
                        Modifier.fillMaxWidth()
                            .testTag(TimelineTags.entry(entry.id))
                            .semantics(mergeDescendants = true) { contentDescription = description }
                            .let { if (canEdit) it.clickable { onEntry(entry) } else it }
                            .padding(vertical = 8.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Box(Modifier.size(10.dp).clip(CircleShape).background(if (warning == null) DeepNavy else if (warning == CheckStatus.EXPIRED) ExpiredText else ExpiringText))
                        Spacer(Modifier.width(12.dp))
                        Column(Modifier.weight(1f)) {
                            Text(entry.valueText(currency), style = MaterialTheme.typography.bodyMedium, color = DarkText, fontWeight = FontWeight.Medium)
                            Text(timeline.datesText(entry), style = MaterialTheme.typography.bodySmall, color = DarkText.copy(alpha = 0.75f))
                        }
                        when {
                            warning != null -> StatusChip(warning.label(), if (warning == CheckStatus.EXPIRED) ExpiredChip else ExpiringChip, if (warning == CheckStatus.EXPIRED) ExpiredText else ExpiringText)
                            current -> StatusChip(stringResource(Res.string.timeline_current), entry.kind.chipColor(), DarkText)
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun StatusChip(text: String, background: Color, color: Color) {
    Text(
        text,
        style = MaterialTheme.typography.labelSmall,
        color = color,
        fontWeight = FontWeight.Bold,
        modifier = Modifier.clip(RoundedCornerShape(8.dp)).background(background).padding(horizontal = 8.dp, vertical = 4.dp)
    )
}

// --- The audit trail --------------------------------------------------------------------------

@Composable
private fun AuditSection(audit: List<TimelineAuditEntry>) {
    Card(colors = CardDefaults.cardColors(containerColor = Color.White), modifier = Modifier.fillMaxWidth()) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
            Text(stringResource(Res.string.timeline_audit_title), style = MaterialTheme.typography.titleSmall, color = DeepNavy, fontWeight = FontWeight.Bold)
            audit.asReversed().take(30).forEach { entry ->
                val what = if (entry.kind == TimelineKind.TAX_RELIEF && entry.fact != null) reliefLabel(entry.fact!!) else entry.kind.label()
                val action = stringResource(
                    when (entry.action) {
                        TimelineAuditAction.ADDED -> Res.string.timeline_action_added
                        TimelineAuditAction.MOVED -> Res.string.timeline_action_moved
                        TimelineAuditAction.CHANGED -> Res.string.timeline_action_changed
                        TimelineAuditAction.REMOVED -> Res.string.timeline_action_removed
                    },
                    what
                )
                val dates = when (entry.action) {
                    TimelineAuditAction.MOVED, TimelineAuditAction.CHANGED ->
                        stringResource(Res.string.timeline_audit_dates, auditDay(entry.previousFrom), auditDay(entry.from))
                    TimelineAuditAction.ADDED -> auditDay(entry.from)
                    TimelineAuditAction.REMOVED -> auditDay(entry.previousFrom)
                }
                Text(
                    stringResource(Res.string.timeline_audit_by, auditTime(entry.at), entry.byName, "$action $dates".trim()),
                    style = MaterialTheme.typography.bodySmall,
                    color = DarkText
                )
            }
        }
    }
}

@Composable
private fun auditDay(day: String?): String =
    day?.let { runCatching { formatDay(LocalDate.parse(it)) }.getOrNull() } ?: stringResource(Res.string.timeline_from_start)

private fun auditTime(at: String): String = runCatching {
    val local = Instant.parse(at).toLocalDateTime(TimeZone.currentSystemDefault())
    "${formatDay(local.date)} ${local.hour.toString().padStart(2, '0')}:${local.minute.toString().padStart(2, '0')}"
}.getOrDefault(at)

// --- The add / change dialog --------------------------------------------------------------------

/** The kinds the add dialog offers: the hire only without one, the end only without one. */
private fun EmployeeTimeline.addableLanes(): List<TimelineLane> = buildList {
    if (hire == null) add(TimelineLane(TimelineKind.HIRE))
    if (end == null) add(TimelineLane(TimelineKind.END))
    lanes.filter { it.kind != TimelineKind.HIRE }.forEach { add(it) }
}

@Composable
private fun TimelineEntryDialog(
    draft: TimelineDraft,
    timeline: EmployeeTimeline,
    problem: String?,
    saving: Boolean,
    onChange: ((TimelineDraft) -> TimelineDraft) -> Unit,
    onSave: () -> Unit,
    onRemove: (() -> Unit)?,
    onDismiss: () -> Unit
) {
    EvoDialog(
        title = stringResource(if (draft.isNew) Res.string.timeline_add_title else Res.string.timeline_edit_title),
        icon = Icons.Default.Timeline,
        onDismiss = onDismiss,
        width = DialogWidth.Regular,
        dismissOnClickOutside = false,
        confirm = DialogAction(stringResource(Res.string.timeline_save), onSave, enabled = !draft.invalidInput, loading = saving),
        neutral = onRemove?.let { DialogAction(stringResource(Res.string.timeline_remove), it, destructive = true) }
    ) {
        if (draft.isNew) {
            val lanes = timeline.addableLanes()
            EvoDropdown(
                label = stringResource(Res.string.timeline_field_kind),
                options = lanes,
                selected = lanes.firstOrNull { it.kind == draft.kind && it.fact == draft.fact },
                onSelected = { lane -> onChange { TimelineDraft.new(lane, timeline.today).copy(from = it.from) } },
                optionLabel = { lane -> if (lane.kind == TimelineKind.HIRE || lane.kind == TimelineKind.END) lane.kind.label() else lane.label() }
            )
        } else {
            Text(
                if (draft.kind == TimelineKind.TAX_RELIEF) draft.fact?.let { reliefLabel(it) }.orEmpty() else draft.kind.label(),
                color = Color.White,
                fontWeight = FontWeight.Bold
            )
        }
        val fromLabel = stringResource(
            when (draft.kind) {
                TimelineKind.HIRE -> Res.string.timeline_field_hire_day
                TimelineKind.END -> Res.string.timeline_field_end_day
                TimelineKind.OHS_TRAINING -> Res.string.timeline_field_training_day
                TimelineKind.MEDICAL_EXAM -> Res.string.timeline_field_exam_day
                TimelineKind.NOTE -> Res.string.timeline_field_day
                else -> Res.string.timeline_field_from
            }
        )
        DialogSection(null) {
            EvoDateField(
                value = draft.from,
                onValueChange = { v -> onChange { it.copy(from = v) } },
                label = fromLabel,
                missingYear = MissingYear.ThisYear
            )
            if (draft.kind.hasEnd) {
                EvoDateField(
                    value = draft.until,
                    onValueChange = { v -> onChange { it.copy(until = v) } },
                    label = stringResource(if (draft.kind.staffCheck != null) Res.string.timeline_field_valid_until else Res.string.timeline_field_until),
                    missingYear = MissingYear.Upcoming
                )
            }
        }
        when (draft.kind) {
            TimelineKind.CONTRACT -> DialogSection(stringResource(Res.string.employee_contract_type)) {
                ContractDropdown(SystemContractType.fromId(draft.contractTypeId)) { type -> onChange { it.copy(contractTypeId = type.name) } }
                EvoTextField(
                    value = draft.declaredHours,
                    onValueChange = { v -> onChange { it.copy(declaredHours = v.filter(Char::isDigit).take(3)) } },
                    label = stringResource(Res.string.timeline_field_hours),
                    keyboardType = androidx.compose.ui.text.input.KeyboardType.Number
                )
            }
            TimelineKind.PAY -> DialogSection(null) {
                EvoSegmented(
                    options = listOf(true, false),
                    selected = draft.isHourly,
                    onSelect = { hourly -> onChange { it.copy(isHourly = hourly) } },
                    optionLabel = { stringResource(if (it) Res.string.timeline_pay_hourly else Res.string.timeline_pay_monthly) }
                )
                if (draft.isHourly) {
                    EvoTextField(
                        value = draft.rate,
                        onValueChange = { v -> onChange { it.copy(rate = v) } },
                        label = stringResource(Res.string.timeline_field_rate),
                        keyboardType = androidx.compose.ui.text.input.KeyboardType.Decimal
                    )
                } else {
                    EvoTextField(
                        value = draft.salary,
                        onValueChange = { v -> onChange { it.copy(salary = v) } },
                        label = stringResource(Res.string.timeline_field_salary),
                        keyboardType = androidx.compose.ui.text.input.KeyboardType.Decimal
                    )
                    EvoTextField(
                        value = draft.fte,
                        onValueChange = { v -> onChange { it.copy(fte = v) } },
                        label = stringResource(Res.string.timeline_field_fte),
                        keyboardType = androidx.compose.ui.text.input.KeyboardType.Decimal
                    )
                }
                Text(stringResource(Res.string.timeline_fte_hint), style = MaterialTheme.typography.bodySmall, color = Color.White.copy(alpha = 0.8f))
            }
            TimelineKind.TAX_RELIEF -> if (draft.isNew) DialogSection(null) {
                EvoDropdown(
                    label = stringResource(Res.string.timeline_field_relief),
                    options = timeline.reliefs,
                    selected = draft.fact,
                    onSelected = { fact -> onChange { it.copy(fact = fact) } },
                    optionLabel = { reliefLabel(it) }
                )
            }
            // SH-232: what the period means, and that counting goes by whole months.
            TimelineKind.UNPAID -> Text(stringResource(Res.string.timeline_unpaid_hint), style = MaterialTheme.typography.bodySmall, color = Color.White.copy(alpha = 0.8f))
            TimelineKind.NOT_COUNTED -> Text(stringResource(Res.string.timeline_not_counted_hint), style = MaterialTheme.typography.bodySmall, color = Color.White.copy(alpha = 0.8f))
            TimelineKind.NOTE -> EvoTextField(
                value = draft.text,
                onValueChange = { v -> onChange { it.copy(text = v.take(com.evoapps.evoshift.domain.timeline.TimelineRules.NOTE_MAX_LENGTH)) } },
                label = stringResource(Res.string.timeline_field_note),
                singleLine = false,
                minLines = 3
            )
            else -> Unit
        }
        problem?.let { Text(it, color = Color(0xFFFFB4AB), style = MaterialTheme.typography.bodyMedium, fontWeight = FontWeight.Medium) }
    }
}
